/* eslint-disable array-callback-return */
import { Accordion, AccordionTab } from "primereact/accordion"
import style from "../../../../styles/Participant-GPRA.module.css"
import AdditionalQuestionGroup from "./AdditionalQuestionGroup"

const AdditionalQuestionMatrix = ({
  question,
  disabled,
  entity,
  errors,
  removeError,
  setEntity,
}) => {
  return (
    <div
      className={style.formRow}
      style={{ marginTop: "1rem", marginLeft: "1rem", width: "97%" }}
    >
      <Accordion activeIndex={question?.expanded ? 0 : undefined}>
        <AccordionTab header={question?.title}>
          {question?.questionGroups
            ?.sort((a, b) => {
              return a.groupOrder - b.groupOrder
            })
            ?.map((group) => {
              if (group.enabled) {
                return (
                  <AdditionalQuestionGroup
                    id={`group_${group.id}`}
                    group={group}
                    disabled={disabled}
                    entity={entity}
                    errors={errors}
                    removeError={removeError}
                    setEntity={setEntity}
                  />
                )
              }
            })}
        </AccordionTab>
      </Accordion>
    </div>
  )
}
export default AdditionalQuestionMatrix
